import dayjs from "dayjs";

export function durationLabel(minutes: number) {
  if (minutes >= 60) return `${minutes / 60} hr`;
  return `${minutes} min`;
}

export function timeToMinutes(time: string) {
  const [hour, minute] = time.split(":").map(Number);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return NaN;
  return hour * 60 + minute;
}

export function minutesToTime(total: number) {
  const hour = Math.floor(total / 60);
  const minute = total % 60;
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
}

export function buildTimeRange(start: string, end: string, stepMinutes: number) {
  const startMinutes = timeToMinutes(start);
  const endMinutes = timeToMinutes(end);
  const step = Math.max(Number(stepMinutes || 30), 5);
  if (Number.isNaN(startMinutes) || Number.isNaN(endMinutes) || endMinutes <= startMinutes) return [];
  const times: string[] = [];
  for (let cursor = startMinutes; cursor < endMinutes; cursor += step) {
    times.push(minutesToTime(cursor));
  }
  return times;
}

export function formatMeetingDate(date: string) {
  const label = dayjs(date).format("dddd, D MMMM YYYY");
  return dayjs(date).isSame(dayjs(), "day") ? `${label}   TODAY` : label;
}

export function formatCreatedAt(createdAt: string) {
  if (!createdAt) return "-";
  return dayjs(createdAt).format("YYYY-MM-DD HH:mm");
}

export function addMinutes(time: string, minutes: number) {
  const [hour, minute] = time.split(":").map(Number);
  return dayjs().hour(hour).minute(minute).add(minutes, "minute").format("HH:mm");
}
